import * as angular from 'angular';
import * as moment from 'moment';

import { ComponentDefinition, Dictionary, Group } from '@models/index';
import { IRequestService } from '@services/request.service';
import { StepProcessingTime } from './StepProcessingTime';
import { IStoreService } from '@services/store.service';
import { StoreElement } from '../../../stateManagement';

class PerformanceHeatMapStateController implements angular.IComponentController {
    availableDates: string[];
    data: StepProcessingTime[];
    groups: Dictionary<Group>;
    isLoading: boolean;
    loadingMessage: string;
    selectedDate: string;

    static $inject = [
        'requestService',
        'storeService'
    ];

    constructor(
        private _requestService: IRequestService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this._storeService.register(
            store => this.groups = store.groups.dictionary,
            [StoreElement.Groups]
        );

        this.refreshProcessedDates()
            .then(() => this.refresh(this.selectedDate));
    }
    
    refreshProcessedDates() {
        const url = 'onlineComputation/getOnlineProcessedDates';
        this._requestService.cleanCacheAtV1(url);
        return this._requestService
            .getAtV1<string[]>(url)
            .then(data => {
                this.availableDates = data.map(d=>moment(d).toISOString());
                if (data && data.length) {
                    this.selectedDate = this.availableDates[0];
                }
            });
    }

    refresh(date: string) {
        if (date) {
            this.isLoading = true;
            const url = 'onlineComputation/getProcessingTime';
            const param = { timeStamp: date };
            this._requestService.cleanCacheAtV1(url, param);
            this._requestService
                .getAtV1<StepProcessingTime[]>(url, param)
                .then(data => this.data = data)
                .finally(() => this.isLoading = false);
        }
    }

    onDateSelected() {
        this.refresh(this.selectedDate);
    }
}

export const wtPerformanceHeatMapState: ComponentDefinition = {
    componentId: 'wtPerformanceHeatMapState',
    controller: PerformanceHeatMapStateController,
    template: require('./performanceHeatMapState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};